export default function(eccent, sinphi, cosphi) {
  var con = eccent * sinphi;
  return cosphi / (Math.sqrt(1 - con * con));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/msfnz.js
// module id = IXc0
// module chunks = 0